import { ShaparakWizardStatusEnum } from "@payping/api";
import { FrontShaparakWizardStatusEnum, StatusIconEnum, StepsType } from "./types";

export const translationKeys = {
  desc: {
    adminConfirm: "adminConfirm",
    adminPending: "adminPending",
    dataRejected: "dataRejected",
    shaparakPending: "shaparakPending",
    shaparakSuccess: "shaparakSuccess",
    terminalSuccess: "terminalSuccess",
    userPending: "userPending",
  },
  noText: "",
  title: {
    completeProfile: "completeProfile",
    confirmProfile: "confirmProfile",
    step3title: "step3title",
    step4title: "step4title",
    successRegistration: "successRegistration",
  },
};

const step1: StepsType = {
  // in step 1, there is JUST 1 state and it's always success! I've added "default" state because of "type" stuff errors, so "success" and "default" are the same!
  default: {
    description: translationKeys.noText,
    icon: StatusIconEnum.success,
    isLastStep: false,
    status: ShaparakWizardStatusEnum.Success,
    step: 1,
    title: translationKeys.title.successRegistration,
  },
  success: {
    description: translationKeys.noText,
    icon: StatusIconEnum.success,
    isLastStep: false,
    status: ShaparakWizardStatusEnum.Success,
    step: 1,
    title: translationKeys.title.successRegistration,
  },
};

const step2: StepsType = {
  adminConfirm: {
    description: translationKeys.desc.adminConfirm,
    icon: StatusIconEnum.pending,
    isLastStep: false,
    status: ShaparakWizardStatusEnum.AdminConfirm,
    step: 2,
    title: translationKeys.title.confirmProfile,
  },
  adminPending: {
    description: translationKeys.desc.adminPending,
    icon: StatusIconEnum.pending,
    isLastStep: false,
    status: ShaparakWizardStatusEnum.AdminPending,
    step: 2,
    title: translationKeys.title.confirmProfile,
  },
  adminReject: {
    description: translationKeys.desc.dataRejected,
    icon: StatusIconEnum.error,
    isLastStep: false,
    status: ShaparakWizardStatusEnum.AdminRejected,
    step: 2,
    title: translationKeys.title.confirmProfile,
  },
  default: {
    description: translationKeys.noText,
    icon: StatusIconEnum.default,
    isLastStep: false,
    status: FrontShaparakWizardStatusEnum.Default,
    step: 2,
    title: translationKeys.title.completeProfile,
  },
  shaparakPending: {
    description: translationKeys.desc.shaparakPending,
    icon: StatusIconEnum.pending,
    isLastStep: false,
    status: ShaparakWizardStatusEnum.ShaparakPending,
    step: 2,
    title: translationKeys.title.confirmProfile,
  },
  shaparakReject: {
    description: translationKeys.desc.dataRejected,
    icon: StatusIconEnum.error,
    isLastStep: false,
    status: ShaparakWizardStatusEnum.ShaparakRejected,
    step: 2,
    title: translationKeys.title.confirmProfile,
  },
  success: {
    description: translationKeys.desc.shaparakSuccess,
    icon: StatusIconEnum.success,
    isLastStep: false,
    status: ShaparakWizardStatusEnum.Success,
    step: 2,
    title: translationKeys.title.confirmProfile,
  },
  userPending: {
    description: translationKeys.desc.userPending,
    icon: StatusIconEnum.userPending,
    isLastStep: false,
    status: ShaparakWizardStatusEnum.NotCompleted,
    step: 2,
    title: translationKeys.title.completeProfile,
  },
};

const step3: StepsType = {
  default: {
    description: translationKeys.noText,
    icon: StatusIconEnum.default,
    isLastStep: false,
    status: FrontShaparakWizardStatusEnum.Default,
    step: 3,
    title: translationKeys.title.step3title,
  },
  success: {
    description: translationKeys.desc.shaparakSuccess,
    icon: StatusIconEnum.success,
    isLastStep: false,
    status: FrontShaparakWizardStatusEnum.Default,
    step: 3,
    title: translationKeys.title.step3title,
  },
};

const step4: StepsType = {
  default: {
    description: translationKeys.noText,
    icon: StatusIconEnum.default,
    isLastStep: false,
    status: FrontShaparakWizardStatusEnum.Default,
    step: 4,
    title: translationKeys.title.step4title,
  },
  success: {
    description: translationKeys.desc.terminalSuccess,
    icon: StatusIconEnum.success,
    isLastStep: false,
    status: FrontShaparakWizardStatusEnum.Default,
    step: 4,
    title: translationKeys.title.step4title,
  },
};

export const defaultState = [{ ...step1.default, isLastStep: true }, step2.default, step3.default, step4.default];

export const userPendingState = [
  step1.default,
  { ...step2.userPending, isLastStep: true },
  step3.default,
  step4.default,
];

export const adminPendingState = [
  step1.default,
  { ...step2.adminPending, isLastStep: true },
  step3.default,
  step4.default,
];

export const adminConfirmState = [
  step1.default,
  { ...step2.adminPending, isLastStep: true },
  step3.default,
  step4.default,
];

export const shaparakPendingState = [
  step1.default,
  { ...step2.shaparakPending, isLastStep: true },
  step3.default,
  step4.default,
];

export const shaparakConfirmState = [
  step1.default,
  { ...step2.success, isLastStep: true },
  step3.default,
  step4.default,
];

export const shaparakRejectState = [
  step1.default,
  { ...step2.shaparakReject, isLastStep: true },
  step3.default,
  step4.default,
];

export const adminRejectState = [
  step1.default,
  { ...step2.adminReject, isLastStep: true },
  step3.default,
  step4.default,
];

export const shaparakSubmitState = [
  step1.default,
  step2.success,
  { ...step3.success, isLastStep: true },
  step4.default,
];

export const successState = [step1.default, step2.success, step3.success, { ...step4.success, isLastStep: true }];
